import { isEmpty, isNil } from 'lodash';

import { FilterFormData } from './components/FilterForm';
import { getShipClient } from '../../app/initializer';
import ListShipData from '../../common/data-types/ship-list-data';
import Ship from '../../common/data-types/ship-data';
import ShipStatus from '../../common/enums/ship-status.enum';

const shipClient = getShipClient();

export interface ListShipParams {
  first: number;
  offset: number;
  filters?: FilterFormData;
  shipName?: string;
}

export const listShips = async ({
  first,
  offset,
  filters,
  shipName,
}: ListShipParams): Promise<ListShipData> => {
  const body = await shipClient.listShips();

  let list = parseList(body);
  let total = list.length;

  if (!isNil(filters) && !isEmpty(filters)) {
    const { arrival, firstSituation, secondSituation } = filters;

    list = filterList({ arrival, firstSituation, secondSituation, list });
    total = list.length;
  }
  list = list.slice(offset, first);
  if (shipName) {
    list = list.filter((item: Ship) =>
      item.ship.toLowerCase().includes(shipName.toLowerCase())
    );
    total = list.length;
  }

  return { list, total };
};

const filterList = ({
  arrival,
  firstSituation,
  secondSituation,
  list,
}: FilterFormData & { list: Ship[] }): Ship[] => {
  let filteredList: Ship[] = list;

  if (arrival > 0) {
    filteredList = filteredList.filter((item: Ship) => {
      if (item.forecastArrival) {
        const today = new Date();
        const periodStart = new Date();
        const arrivalDate = item.forecastArrival;

        periodStart.setDate(today.getDate() - arrival);

        return arrivalDate >= periodStart;
      }
      return false;
    });
  }

  filteredList = filteredList.filter((item: Ship) => {
    if (
      firstSituation === ShipStatus.Todos ||
      secondSituation === ShipStatus.Todos
    ) {
      return true;
    }

    return item.status === firstSituation || item.status === secondSituation;
  });

  return filteredList.sort((a, b) => {
    if (a.forecastArrival > b.forecastArrival) return 1;
    if (a.forecastArrival < b.forecastArrival) {
      return -1;
    }
    return 0;
  });
};

// #region Parsers
const parseList = (data: Record<string, any>[]): Ship[] => {
  return data.map((item: Record<string, any>) => {
    const ship: Ship = {
      id: item.ItemInternalId,
      rowNumber: item.ROW_NUM,
      status: 'Na Barra',
      ship: item.NAVIO,
      trip: item.VIAGEM,
      rap: item.RAP,
      joint: item.JOINT,
      gateOpening: item.ABERTURAGATE && new Date(item.ABERTURAGATE),
      cradle: item.BERCO,
      deadline: item.DEADLINE && new Date(item.DEADLINE),
      forecastArrival: item.PREVISAOCHEGADA && new Date(item.PREVISAOCHEGADA),
      arrival: item.CHEGADA && new Date(item.CHEGADA),
      forecastMooring:
        item.PREVISAOATRACACAO && new Date(item.PREVISAOATRACACAO),
      mooring: item.ATRACACAO && new Date(item.ATRACACAO),
      operationStart: item.INICIOOPERACAO && new Date(item.INICIOOPERACAO),
      finish: item.TERMINO && new Date(item.TERMINO),
      forecastDeparture: item.PREVISAOSAIDA && new Date(item.PREVISAOSAIDA),
      departure: item.SAIDA && new Date(item.SAIDA),
    };

    ship.status = getShipStatus(ship);

    return ship;
  });
};

const getShipStatus = (ship: Ship): Ship['status'] => {
  if (ship.forecastArrival !== undefined && ship.arrival === undefined)
    return ShipStatus.Esperados;

  if (ship.arrival !== undefined && ship.mooring === undefined)
    return ShipStatus.NaBarra;

  if (ship.mooring !== undefined && ship.departure === undefined)
    return ShipStatus.Atracados;

  if (ship.departure !== undefined) return ShipStatus.Desatracados;

  return '';
};
// #endregion Parsers
